// ng build --prod --env=emmpro --bh /oficina/
// ng build --prod --env=emmpro
// npm run-script build:emmpro
export const environment = {
  production: true,
  urlApi: 'https://acuamaemmasa.sacyr.com/webapi/api/',
  site: 'Emmasa',
  logo: 'logo-valoriza.png',
  pie: 'Emmasa',
  faqs: 'emmasa',
  capchasiteKey: '6Ld801IUAAAAAOTvnkTeD_SQ--klB_VcZ8y2pTdo',
  version: '0.1',
  ganalytics: 'UA-11568983-39',
  ContactaText: 'Dudas y Reclamaciones',
  urlTPV: 'https://acuamaemmasa.sacyr.com/webapi/TPVRedsys/EnviarDatosTPV'
};
